import { render, staticRenderFns } from "./InsurancePayment.vue?vue&type=template&id=075f0dfa&scoped=true&"
import script from "./InsurancePayment.ts?vue&type=script&lang=ts&"
export * from "./InsurancePayment.ts?vue&type=script&lang=ts&"
import style0 from "./InsurancePayment.vue?vue&type=style&index=0&id=075f0dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075f0dfa",
  null
  
)

export default component.exports